<div class="venue-container">

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
</ngx-spinner>
<div>
  <div class="search-row align-center">
     <div class="input-with-icon d-flex flex-column-reverse">
        <input
          style="font-weight: 400; font-size: 2em; height: 50px; margin-right: 10px;"
          type="text"
          placeholder="Your Venue Name"
          [value]="venueName"
          [(ngModel)]="venueName"
          class="searchtext"
          (keyup)="checkNameValidity()"
        />
        <small class="text-danger position-absolute" *ngIf="isNameError">
          Please enter venue name
        </small>
    </div>
    <button [disabled]="isNameError" class="lrg-btn btn-info" (click)="save()">
      Save
    </button>
    <button class="lrg-btn btn-danger" (click)="cancel()">
      Cancel
    </button>
  </div>
  <small class="text-danger" *ngIf="isImageError" style="float: right; margin-right: 25%;"> Please upload an image </small>
  <div class="venue-table">
    <div class="table-cell">
      <div class="data-row-col" style="margin-right: 15px;">
        <div #sectionsRef tabindex="1" class="data-row">
          <div class="data-row-content">
            <div style="overflow: hidden;" class="content-cell">
              <div class="cell-row">
                <div class="section-group-container">
                  <div *ngIf="venue" class="section-container">
                    <div
                      *ngFor="let section of venue.venueSections"
                      class="align-center"
                      [ngClass]="{ 'selected-list-item': section.selected, 'list-item': !section.selected}"
                      (click)="selectSection(section);">
                      <span onselectstart="return false">{{section.name}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-row">
                <button class="lrg-btn dark-btn" (click)="openSectionInputModal()">
                  + Section
                </button>
                <div class="input-with-icon align-row" style="border: 1px solid rgba(0,0,0,.1);">
                  <input
                    type="text"
                    placeholder="New Section Name"
                    [(ngModel)]="newSectionName"
                    class="venue-text-input"
                    style="width: 13em"
                    (keyup.enter)="createNewSection()"
                    (keyup)="changeSectionName()"
                  />
                  <button class="section-group-delete"><img alt=""
                    src="assets/app/media/img/tools/delete.png"
                    (click)="deleteSelectedSections()"
                  ></button>
                </div>
              </div>
              <span> Press Enter to add a new section </span>
            </div>
          </div>
        </div>

        <div class="data-row">
          <div class="data-row-content">
            <div style="overflow: hidden;" class="content-cell">
              <div class="cell-row">
                <div class="section-group-container">
                  <div *ngIf="venue" class="section-container" style="max-height: 200px;">
                    <div
                      *ngFor="let group of venue.venueGroups"
                      class="align-center"
                      [ngClass]="{ 'selected-list-item': group === selectedGroup, 'list-item': group !== selectedGroup }"
                      (click)="selectGroup(group);">
                      <span onselectstart="return false">{{group}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell-row">
                <button [disabled]="isGroupNameError" class="lrg-btn dark-btn" (click)="createNewGroup()">
                  + Group
                </button>
                <div class="input-with-icon align-row" style="border: 1px solid rgba(0,0,0,.1);">
                  <input
                    type="text"
                    placeholder="New Group Name"
                    (keyup)="changeGroupName()"
                    [(ngModel)]="newGroupName"
                    class="venue-text-input"
                    (keyup.enter)="createNewGroup()"
                  />
                  <button class="section-group-delete"><img alt=""
                    src="assets/app/media/img/tools/delete.png"
                    (click)="deleteSelectedGroup()"
                  ></button>
                </div>
              </div>
              <span
                class="text-danger small"
                *ngIf="isGroupNameError"
              >
                Please enter correct group name with size between 1 and 30 characters
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="data-row">
        <div class="data-row-content ">
          <div class="content-cell">
            <div class="cell-row">
              <div class="img-container align-center">
                <div *ngIf="venue && venue.imageUrl !== ''"  class="canvasImageContainer">
                  <canvas
                    [ngClass]="{ 'crosshair': selectedTool !== '', 'default': selectedTool === '' }"
                    width="1536"
                    height="864"
                    (mousemove)="mouseEvent($event);"
                    (mousedown)="mouseEvent($event);"
                    (mouseup)="mouseEvent($event);"
                    class="venueCanvas"
                    #venueRef>
                      Your browser does not support HTML5 canvas :(
                  </canvas>
                  <img
                    (load)="loadCanvas()"
                    onselectstart="return false"
                    style='width: 100%; height: auto;'
                    class="image"
                    alt="" [src]="venue.imageUrl"
                    [style.opacity]="opacity / 100"
                    onerror="if (this.src != 'assets/app/media/img/error/img-not-found.png')
                      this.src = 'assets/app/media/img/error/img-not-found.png';">
                </div>
                <input
                    *ngIf="venue && venue.imageUrl === ''"
                    type="file"
                    (change)="uploadPng($event.target.files[0])"
                    name="file-1[]"
                    id="file-1"
                    class="venue-fileinput"
                    accept="image/png, image/jpg, image/jpeg"
                  />
                <img
                  *ngIf="venue && (!venue.imageUrl || venue.imageUrl === '')"
                  alt="" src="assets/app/media/img/misc/sample_seating.jpg">
                <span
                  onselectstart="return false"
                  class="img-text"
                  *ngIf="venue && (!venue.imageUrl || venue.imageUrl === '') && validImageType">
                    Click here to upload an image of your venue's seating chart
                </span>
                <span
                  class="m-form__help"
                  style="color:red; position:absolute; top:50%;"
						      *ngIf="!validImageType">
						      Please upload either a .png, .jpg, or .jpeg file.
					      </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data-row-col" style="width: auto;">
        <div class="tools-row">
          <div class="data-row-content tool-icon">
            <img alt=""
              src="assets/app/media/img/tools/multiselect.png"
              [ngClass]="{ 'selected-tool': selectedTool === 'multiselect' }"
              (click)="selectTool('multiselect')"
              placement="left" container="body" tooltip="Multiselect Tool" delay="500"
            >
          </div>
          <div class="data-row-content tool-icon">
            <img alt=""
              src="assets/app/media/img/tools/undo.png"
              (click)="undoDraw()"
              placement="left" container="body" tooltip="Undo Point Placement" delay="500"
            >
          </div>
          <!--<div class="data-row-content tool-icon">
            <img style="transform: scaleX(-1);" alt=""
              src="assets/app/media/img/tools/undo.png"
              (click)="redo()"
            >
          </div>-->
          <div class="data-row-content tool-icon">
            <img alt=""
              src="assets/app/media/img/tools/polygon.png"
              [ngClass]="{ 'selected-tool': selectedTool === 'polygon', 'tool-disabled': toolDisabled('polygon') }"
              (click)="selectTool('polygon')"
              placement="left" container="body" tooltip="Polygon Tool" delay="500"
            >
          </div>
          <div class="data-row-content tool-icon">
            <img alt=""
              src="assets/app/media/img/tools/rectangle.png"
              [ngClass]="{ 'selected-tool': selectedTool === 'rectangle', 'tool-disabled': toolDisabled('rectangle') }"
              (click)="selectTool('rectangle')"
              placement="left" container="body" tooltip="Rectangle Tool" delay="500"
            >
          </div>
          <div class="data-row-content tool-icon">
            <img alt=""
              src="assets/app/media/img/tools/circle.png"
              [ngClass]="{ 'selected-tool': selectedTool === 'circle', 'tool-disabled': toolDisabled('circle') }"
              (click)="selectTool('circle')"
              placement="left" container="body" tooltip="Circle Tool" delay="500"
            >
          </div>
          <div class="data-row-content tool-icon">
            <img alt=""
              src="assets/app/media/img/tools/delete.png"
              (click)="deleteShape()"
              placement="left" container="body" tooltip="Delete Shapes" delay="500"
            >
          </div>

          <div class="data-row-content tool-icon">
            <input
              [(ngModel)]="opacity"
              type="range" class="opacity-slider" min="1" max="100" value="100"
              placement="left" container="body" tooltip="Image Opacity" delay="500"
              >
          </div>
        </div>

      </div>
  </div>
</div>
